/**
 * 
 */

var eventManager={
		
		 _elementRegistered : [],
		
		register : function (element){
			this._elementRegistered.push(element);
		},
		
		fireEvent :  function(event) {
			for (var registeredEltIdx in this._elementRegistered ){
				this._elementRegistered[registeredEltIdx].handleEvents(event);
			}
		}
		
}